<template>
  <dashboard-widget
    :is-loading="isLoading">
    <template>
      <div class="active-leads-wrapper">
        <div class="widget-header">
          <h4 class="inline-block">{{ $t('ui.dashboard.active_leads.label') }}</h4>
        </div>

        <div class="card-wrapper row">
            <div v-for="mostActiveLead in mostActiveLeads" :key="mostActiveLead.index" class="lead-card col-xs-4 col-md-2">
                <div class="icon-classification">
                    <img
                      v-if="mostActiveLead.classification === 'warm'"
                      class="align-center"
                      src="../../../../../assets/leads-count-yellow.svg"
                    />
                    <img
                      v-else-if="mostActiveLead.classification === 'hot'"
                      class="align-center"
                      src="../../../../../assets/leads-count-red.svg"
                    />
                    <img
                      v-else-if="mostActiveLead.classification === 'cold'"
                      class="align-center"
                      src="../../../../../assets/lead-count-cold-green.svg"
                    />
                    <img v-else class="align-center" src="../../../../../assets/leads-count-gray.svg" />
                </div>
                <div>
                    <p
                      class="truncate-text">
                      {{ mostActiveLead.name }}</p>
                    <p class="caption truncate-text">{{ mostActiveLead.company }}</p>
                </div>
            </div>
        </div>
      </div>
    </template>
  </dashboard-widget>
</template>

<script>
import join from 'lodash/join'
import isNull from 'lodash/isNull'
import find from 'lodash/find'
import flow from 'lodash/flow'
import eq from 'lodash/eq'
import isUndefined from 'lodash/isUndefined'
import map from 'lodash/fp/map'
import slice from 'lodash/fp/slice'
import reject from 'lodash/fp/reject'

import Charts from '@/api/Charts.js'
import Api from '@/api/Api.js'
import WidgetMixin from './mixins/WidgetMixin'
import WidgetPeriodMixin from './mixins/WidgetPeriodMixin'
import WidgetQueryMixin from './mixins/WidgetQueryMixin'

const MOST_ACTIVE_LEADS_LIMIT = 5

export default {
  mixins: [WidgetMixin, WidgetPeriodMixin, WidgetQueryMixin],

  props: {
    identifier: {
      type: String,
      default: 'most-active-leads'
    }
  },

  data: () => ({
    mostActiveLeads: []
  }),

  methods: {

    async refresh() {
        this.setIsLoading(true)

        try {
            let mostActiveLeads = await this.get(this.from(this.filter.period), this.filter.projectId)
            this.mostActiveLeads = this.transform(mostActiveLeads)
        } catch (error) {
            this.setError(error)
            this.setIsError(true)
        } finally {
            this.setIsLoading(false)
            this.eventBus.$emit('widget-loaded', this.identifier)
        }
    },

    get (from, project) {
      return new Promise(async (resolve, reject) => {
        let charts = new Charts()

        let tuples = [
          { key: 'from', value: `"${from}"` },
          { key: 'limit', value: ACTIVITIES_LIMIT }
        ]

        if (!!project) {
          tuples.push({ key: 'projectId', value: project })
        }

        const querySchema = `
          lead_id
          interactions_count
        `
        const query = this.getQuery(tuples, 'latestEvents', querySchema)
        let { most_active_leads: mostActiveLeads } = await charts.postQuery({
          organization_id: this.filter.organizationId,
          operationName: null,
          variables: {},
          query: `query Query {
            ${query}
          }`
        })

        let api = new Api()
        try {
          const leads = await api.getMultiple('leads', 'id', join(map(({ lead_id }) => lead_id)(mostActiveLeads)))
        } catch (error) {
          reject(error)
        }

        mostActiveLeads = map(mostActiveLead => {
          // Get lead
          if (!isNull(mostActiveLead.lead_id)) {
            mostActiveLead.lead = find(leads, ['id', mostActiveLead.lead_id])
          }

          return mostActiveLead
        })(mostActiveLeads)

        resolve(mostActiveLeads)
     })
    },

    transform: mostActiveLeads => flow([
      reject(activity => isUndefined(activity.lead) || isUndefined(activity.project)),
      map((mostActiveLead, index) => ({
        index,
        classification: mostActiveLead.lead.classification,
        company: mostActiveLead.lead.company,
        name: `${mostActiveLead.lead.firstname} ${mostActiveLead.lead.lastname}`
      }))
    ])(mostActiveLeads)
  }
}
</script>

<style lang="sass">
.active-leads-wrapper
  margin-bottom: 20px
  .widget-header
    margin-bottom: 20px
    h4
      margin-top: 0px !important
      text-align: center
      color: $paper-lighter
      margin-bottom: 0px

  .card-wrapper
    p
      text-align: center
      color: $paper-dark
      margin-bottom: 0px
    .caption
      color: $ink-lighter
    .icon-classification
      margin-bottom: 10px
      img
        display: block
        margin: auto !important

    .lead-card
      padding: 15px
      border-radius: 5px
      transition: all .15s ease-out
      &:hover
        background: rgba(69, 74, 91, 0.45)
        cursor: pointer
    .inline-block
      display: inline-block
      padding: 10px
    .align-center
      text-align: center

select
  background-color: $paper
  border: 2px solid $paper
  color: $ink-dark
  height: 30px
  padding-left: 10px
  border-radius: 3px
  transition: all .15s ease-out
  font-size: 12px
  &::placeholder
    color: $ink-dark
    font-size: 12px
  &:hover
    background-color: $paper-dark
    border: 2px solid $paper-dark
  &:active
    background-color: #ffffff
    border: 2px solid $sensual
  &:focus
    background-color: #ffffff
    border: 2px solid $sensual
</style>



// WEBPACK FOOTER //
// MostActiveLeadsWidget.vue?6dcff2c1